export enum SharedPresentationalMapsBooleanToggleSettingsName {
  allowSatelliteView = 'allowSatelliteView',
  allowStreetView = 'allowStreetView',
  boundaryTool = 'boundaryTool',
  displayLegendOnly = 'displayLegendOnly',
  displaySearchBox = 'displaySearchBox',
  displayTitleAndDescription = 'displayTitleAndDescription',
  distanceCalculator = 'distanceCalculator',
  filterMenusOpen = 'filterMenusOpen',
  filterTool = 'filterTool',
  groupingTool = 'groupingTool',
  heatMappingTool = 'heatMappingTool',
  lassoTool = 'lassoTool',
  legendReplacesGrouping = 'legendReplacesGrouping',
  locationFinder = 'locationFinder',
  locationFinderStartsOpen = 'locationFinderStartsOpen',
  mapKey = 'mapKey',
  mapKeyOpen = 'mapKeyOpen',
  mapImageExport = 'mapImageExport',
  mapToolsMenuOpen = 'mapToolsMenuOpen',
  mapZoom = 'mapZoom',
  markersVisibilityButton = 'markersVisibilityButton',
  radiusProximity = 'radiusProximity',
  restrictMapPanning = 'restrictMapPanning',
  routingDirections = 'routingDirections',
  searchBarAlwaysVisible = 'searchBarAlwaysVisible',
  showSearchFilter = 'showSearchFilter',
  showMyLocation = 'showMyLocation',
  showMyLocationDefault = 'showMyLocationDefault',
}

export enum SharePresentationalMapsButtonsName {
  embedMap = 'embedMap',
  restrictZoomLevels = 'restrictZoomLevels',
  showHideDataOnMarker = 'showHideDataOnMarker',
  showHideDataFromExport = 'showHideDataFromExport',
  showHideFilterColumns = 'showHideFilterColumns',
  presentationalDataExportAuthorize = 'presentationalDataExportAuthorize',
  presentationalDataExportAllowTools = 'presentationalDataExportAllowTools',
}
